export const SEARCH = 'investigation-search';

export const onSearch = term => {
    return {
        type: SEARCH,
        term
    };
}
